import React from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';
import { GOOGLE_MAP_API_KEY } from '../../configs';

export const GoogleMapsProvider = ({ children }) => {
  return (
    <APIProvider
      apiKey={GOOGLE_MAP_API_KEY}
      version="3.64"
      libraries={['places', 'visualization']}
    >
      {children}
    </APIProvider>
  );
};
